"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _withFileUpdater = _interopRequireDefault(require("../../withFileUpdater"));

var _Shot = _interopRequireDefault(require("../../Shot"));

var _NewShot = _interopRequireDefault(require("../../NewShot"));

var _ReadOnlyShot = _interopRequireDefault(require("../../ReadOnlyShot"));

var _shotTypes = _interopRequireDefault(require("../../../constants/shotTypes"));

function DroppableShotsArea(_ref) {
  var shots = _ref.shots,
      aspectRatio = _ref.aspectRatio,
      organisationId = _ref.organisationId,
      selectedShotIndex = _ref.selectedShotIndex,
      createShot = _ref.createShot,
      updateShot = _ref.updateShot,
      updateShotAssets = _ref.updateShotAssets,
      storyboardPermissions = _ref.storyboardPermissions,
      hasUpdatePermission = _ref.hasUpdatePermission,
      addFileToQueue = _ref.addFileToQueue;
  var ShotComponentWrapper = (0, _withFileUpdater.default)(_Shot.default, _shotTypes.default.EXISTING_SHOT);
  var NewShotComponentWrapper = (0, _commonReact.requiresPermission)({
    ComponentToRender: (0, _withFileUpdater.default)(_NewShot.default, _shotTypes.default.NEW_SHOT),
    requiredPermission: 'UPDATE'
  });
  return _react.default.createElement(_react.Fragment, null, shots.map(function (shot, index) {
    var shotKey = shot.shotId || shot.tempId || '';
    return hasUpdatePermission ? _react.default.createElement(ShotComponentWrapper, {
      addFileToQueue: addFileToQueue,
      updateShot: updateShot(shotKey),
      updateShotAssets: updateShotAssets,
      index: index,
      key: shotKey,
      shotKey: shotKey,
      aspectRatio: aspectRatio,
      organisationId: organisationId,
      selectedShotIndex: selectedShotIndex,
      description: shot.description,
      script: shot.script,
      assetId: shot.assetId,
      name: shot.name
    }) : _react.default.createElement(_ReadOnlyShot.default, (0, _extends2.default)({
      key: shotKey,
      index: index
    }, shot));
  }), _react.default.createElement(NewShotComponentWrapper, {
    aspectRatio: aspectRatio,
    organisationId: organisationId,
    addFileToQueue: addFileToQueue,
    createShot: createShot,
    updateShotAssets: updateShotAssets,
    permissions: storyboardPermissions
  }));
}

var _default = (0, _react.memo)(DroppableShotsArea);

exports.default = _default;